import { render, staticRenderFns } from "./PartnerEdit.vue?vue&type=template&id=2c3c4db5&scoped=true"
import script from "./PartnerEdit.vue?vue&type=script&lang=js"
export * from "./PartnerEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3c4db5",
  null
  
)

export default component.exports